import { createClient } from "@supabase/supabase-js";
import { Scene_data } from "../constants/scene_data";
import { Material_data } from "../constants/material_data";

export const DB = createClient(
  "https://gmcdxrwibvsetnsqlnbi.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtY2R4cndpYnZzZXRuc3FsbmJpIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTkyNjM3ODIsImV4cCI6MjAxNDgzOTc4Mn0.Efrt1Ad2poHDAXR6pEz-A8ml9GJL4-dOUum2UPP664E"
);

export const getMaterialsData = async () => {
  return Material_data.filter((item) => item.visible);
};


export const getProductsData = async () => {
  return Scene_data;
};
